import { operatorService } from '@/_services'

export const operators = {
  namespaced: true,
  state: {
    all: {},
    loading: false,
  },
  actions: {
    getAll({ commit }: any) {
      commit('GET_ALL_REQUEST')

      operatorService.getAll().then(
        (allUsers: any) => commit('GET_ALL_SUCCESS', allUsers),
        (error: any) => commit('GET_ALL_FAILURE', error)
      )
    }
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allUsers: any) {
      state.all = { items: allUsers }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any, error: any) {
      state.loading = false
    }
  }
}
